// extracted by mini-css-extract-plugin
export default {"cart-item":"cartItem_cart-item__BQrjC","summary":"cartItem_summary__trEKU","price":"cartItem_price__A7iac","amount":"cartItem_amount__5O8Z9","actions":"cartItem_actions__ovX2G"};